import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';
import type { UserRole } from '../../types';

interface RoleGuardProps {
  allow: UserRole[];
  children: ReactNode;
}

export function RoleGuard({ allow, children }: RoleGuardProps) {
  const user = useAuthStore((s) => s.user);
  if (!user || !allow.includes(user.role as UserRole)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
